import { ExGetterTree } from "vuex";
import { State, Getters } from "./types";
import { ApiRequest } from "@/api/types";

const getters: ExGetterTree<State, Getters> = {
  // @ts-ignore 拡張した型の場合エラーが出るため、一旦無効化
  getNotificationsByQuery: state => (params: ApiRequest.GetNotifications) => {
    const { offset, limit } = params;
    // NOTE 存在しない場合、空の配列が返る
    return state.notifications.slice(offset, offset + limit);
  },
  isHeaderNotificationBadgeVisible(state) {
    if (!state.newArrivalNotifications.length) return false;
    if (!state.newArrivalNotificationSnapshotForHeaderBadge) return true;

    return (
      state.newArrivalNotificationSnapshotForHeaderBadge.id !==
      state.newArrivalNotifications[0].id
    );
  }
};

export default getters;
